import styled from "styled-components";
import { setFontVariant, colorsPalettes, rgba } from "@similarweb/styles";
import {
    CenteredFlexColumn,
    CenteredFlexRow,
    LeftFlexRow,
    RightFlexRow,
} from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { SWReactIcons } from "@similarweb/icons";

export const Icon = styled(SWReactIcons)`
    svg path {
        fill: ${colorsPalettes.carbon[500]};
        stroke: ${colorsPalettes.carbon[500]};
    }
`;

export const BackContainer = styled(CenteredFlexRow)`
    ${setFontVariant("button", colorsPalettes.midnight[600])};
    cursor: pointer;
    gap: 6px;
    padding: 8px 16px;
    border-radius: 18px;
    width: fit-content;

    position: absolute;
    top: 13px;
    left: 18px;

    &:hover {
        background-color: ${rgba(colorsPalettes.carbon[200], 0.2)};
    }
`;

export const Container = styled(CenteredFlexColumn)``;

export const TitlesContainer = styled(CenteredFlexColumn)`
    gap: 8px;
    margin-bottom: 24px;
`;

export const Title = styled.div`
    ${setFontVariant("h3", colorsPalettes.carbon[500])};
`;

export const SubTitle = styled(LeftFlexRow)`
    ${setFontVariant("subtitle2", colorsPalettes.carbon[500])};
`;

export const PaginationBorder = styled.hr`
    width: 100%;
    position: absolute;
    bottom: 48px;
    margin: 0;
`;

export const PaginationContainer = styled(RightFlexRow)`
    height: 48px;
    width: 100%;
`;
